import styled from '@emotion/styled'
import { formatDateString, MediaQuery, useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacIcon } from '@pharmac/ui'
import { useNavigate } from 'react-router-dom'
import { useNewsletters } from '../../features/newsletters/useNewsletters'
import { useExtranetPath } from '../../router/useExtranetPath'
import { ExtranetCard } from '../extranet/ExtranetCard'

const FrontpageNewslettersRoot = styled.div<{ noPadding: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;

  ${MediaQuery.minDesktop} {
    padding-right: ${({ noPadding }) => (noPadding ? 0 : 'var(--spacing-medium)')};
  }

  ${MediaQuery.maxTablet} {
    flex-direction: column;
    align-items: center;
  }
`

const NewslettersFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: var(--spacing-medium);

  ${MediaQuery.maxTablet} {
    padding: 0 var(--spacing-large);
    padding-top: var(--spacing-large);
  }
`

type FrontpageNewslettersProps = {
  isDoseDispensingCustomer?: boolean
}

export const FrontpageNewsletters = ({ isDoseDispensingCustomer }: FrontpageNewslettersProps) => {
  const { t, i18n } = useLanguage()
  const { minDesktop } = useBreakpoint()

  const { newsletters } = useNewsletters({
    page: 1,
    pageSize: isDoseDispensingCustomer ? 3 : 4,
    lang: i18n.language,
  })

  const navigate = useNavigate()
  const createLink = useExtranetPath()

  return (
    <FrontpageNewslettersRoot noPadding={!isDoseDispensingCustomer}>
      {newsletters &&
        newsletters.map((n) => (
          <ExtranetCard
            style={minDesktop ? { height: '300px' } : {}}
            width={isDoseDispensingCustomer ? undefined : '25%'}
            key={'newsletter/' + n.id}
            title={n.title}
            date={formatDateString(n.newsletterDate)}
            image={n.image}
            category={n.category.name}
            onClick={() => navigate(createLink('support.newsletter', { id: n.id }))}
          />
        ))}
      <NewslettersFooter style={!minDesktop ? { justifyContent: 'center' } : {}}>
        <PharmacButton
          fullWidth={!minDesktop}
          onClick={() => navigate(createLink('support.newsletters'))}
        >
          <div style={{ marginRight: 'var(--spacing-small)' }}>
            {t('newsletters.allNewsletters')}
          </div>
          <PharmacIcon
            size="20"
            icon="arrowRight"
          />
        </PharmacButton>
      </NewslettersFooter>
    </FrontpageNewslettersRoot>
  )
}
